module.exports = __webpack_public_path__ + "img/tomato--green.6c39a608.svg";